export default {
  SET_EFFICIENCY(state, payload) {
    state.efficiency = payload
  },
  SET_PORTFOLIOS(state, payload) {
    state.portfolios = payload
  },
}
